import axios from "axios";
import {getBaseUrl} from "../config";

const updateWaitingRoomStatus = (waitingRoomStatus, sessionId, patientId) => {
    const baseUrl = getBaseUrl();
    return axios.post(`${baseUrl}/services/visio/session/${sessionId}/waitingRoomStatus/${waitingRoomStatus}/for/${patientId}`);
};

export { updateWaitingRoomStatus };